// Catalogo de telas + preferencias por usuario (fixadas / 7 recentes) em localStorage.
// Sem backend: segue o mesmo padrao de palette/mode/user do GlobalVar.jsx.

// Telas fixas de navegacao (espelha Sidebar OP_ITEMS + TI_ITEMS). ti:true = so para TI/Admin.
import { ehRestrito, podeAcessarTela } from './acessoTela';

export const TELAS_FIXAS = [
    { id: 'Dashboard',     to: '/Dashboard',     label: 'Dashboard',         icon: 'dashboard' },
    { id: 'Crontab',       to: '/Crontab',       label: 'Crontab Visual',    icon: 'crontab' },
    { id: 'Internas',      to: '/Internas',      label: 'Páginas Internas',  icon: 'pages' },
    { id: 'Arquivos',      to: '/Arquivos',      label: 'Acesso a Arquivos', icon: 'files' },
    { id: 'Logs',          to: '/Logs',          label: 'Logs & Histórico',  icon: 'logs' },
    { id: 'Alertas',       to: '/Alertas',       label: 'Alertas',           icon: 'alerts' },
    { id: 'Configuracoes', to: '/Configuracoes', label: 'Configurações',     icon: 'settings' },
    { id: 'TI/Logins',     to: '/TI/Logins',     label: 'Logins & Usuários', icon: 'shield',   ti: true },
    { id: 'TI/Permissoes', to: '/TI/Permissoes', label: 'Permissões',        icon: 'grid',     ti: true },
    { id: 'TI/PermissoesMemoria', to: '/TI/PermissoesMemoria', label: 'Permissões da Memória', icon: 'grid', ti: true },
    { id: 'TI/SessoesMemoria',    to: '/TI/SessoesMemoria',    label: 'Sessões da Memória',    icon: 'shield', ti: true },
    { id: 'TI/Bancos',     to: '/TI/Bancos',     label: 'Conexões de Banco', icon: 'database', ti: true },
    { id: 'TI/Construtor', to: '/TI/Construtor', label: 'Construtor de API', icon: 'wand',     ti: true },
    { id: 'TI/Telegram',   to: '/TI/Telegram',   label: 'Telegram',          icon: 'telegram', ti: true },
    { id: 'TI/Monitor',    to: '/TI/Monitor',    label: 'Monitor',           icon: 'logs',     ti: true },
];

const MAX_RECENTES = 7;
const chave = (userId, sufixo) => `centralbabita.${sufixo}.${userId || 'anon'}`;

function leLista(k) {
    try { const r = localStorage.getItem(k); return r ? JSON.parse(r) : []; } catch { return []; }
}
function gravaLista(k, v) {
    try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* quota/privado: ignora */ }
}
const limpa = (t) => ({ to: t.to, label: t.label, icon: t.icon || 'pages', externo: !!t.externo });

// ---- Fixadas ----
export function getFixadas(userId) { return leLista(chave(userId, 'telasFixadas')); }
export function isFixada(userId, to) { return getFixadas(userId).some(t => t.to === to); }
export function toggleFixada(userId, tela) {
    const k = chave(userId, 'telasFixadas');
    const lista = leLista(k);
    const i = lista.findIndex(t => t.to === tela.to);
    if (i >= 0) lista.splice(i, 1);
    else lista.push(limpa(tela));
    gravaLista(k, lista);
    return lista;
}

// ---- Recentes (as 7 ultimas telas usadas) ----
export function getRecentes(userId) { return leLista(chave(userId, 'telasRecentes')); }
export function pushRecente(userId, tela) {
    if (!tela || !tela.to || tela.to === '/') return getRecentes(userId);
    const k = chave(userId, 'telasRecentes');
    let lista = leLista(k).filter(t => t.to !== tela.to);
    lista.unshift(limpa(tela));
    if (lista.length > MAX_RECENTES) lista = lista.slice(0, MAX_RECENTES);
    gravaLista(k, lista);
    return lista;
}

// ---- Catalogo completo (nav fixo filtrado por TI + paginas internas dinamicas) ----
export function montaCatalogo(user, internas) {
    const ehTI = !!(user && (user.setor === 'TI' || user.cargo === 'Administrador'));
    const restrito = ehRestrito(user);
    const base = TELAS_FIXAS.filter(t => restrito ? t.id === 'Internas' : (!t.ti || ehTI));
    const inter = (internas || [])
        .filter(p => p && p.slug && (!restrito || podeAcessarTela(user, p)))
        .map(p => ({
            id: 'in_' + p.slug,
            to: (p.tipo === 'react' && p.rota) ? p.rota : (p.tipo === 'link' ? p.url : `/internas/${p.slug}`),
            label: p.titulo || p.slug,
            icon: 'pages',
            externo: p.tipo === 'link',
        }))
        .filter(t => t.to);
    const vistos = new Set();
    const todas = [];
    for (const t of [...base, ...inter]) {
        if (!vistos.has(t.to)) { vistos.add(t.to); todas.push(t); }
    }
    return todas;
}

// Resolve um rotulo legivel para uma rota (catalogo -> internas -> path).
export function labelDe(to, catalogo) {
    const found = (catalogo || TELAS_FIXAS).find(t => t.to === to);
    if (found) return found.label;
    if (to && to.startsWith('/internas/')) return decodeURIComponent(to.replace('/internas/', '')).replace(/-/g, ' ');
    if (to && to.startsWith('/personalizados/')) return decodeURIComponent(to.replace('/personalizados/', '')).replace(/-/g, ' ');
    return to || '';
}
export function iconeDe(to, catalogo) {
    const found = (catalogo || TELAS_FIXAS).find(t => t.to === to);
    return found ? (found.icon || 'pages') : 'pages';
}
